"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CouponTypes = void 0;
exports.CouponTypes = {
    Coupon: 'coupon',
    Referral: 'referral',
};
